export const stringConfig = {
  submit: "SUBMIT",
  cancel: "CANCEL",
  addUser: "Add User",
  updateUser: "Update User",
  searchPlaceholder: "Search..",
  actions: "Actions",
  detailView: "Detail View",
  accountSettings: "Account Details",
  select: "Select",
  passwordRequired: "Password is required",
};

export const errorConfig = {
  noInternet: "No Internet Connection",
};

export const dashboardStrings = {
  orderEntryPortal: "Domestic Order Entry BOT",
};

export const moduleNameString = {
  configuration: "Configuration",
  ltlCustomers: "LTL Customers",
};

export const messageStrings = {
  emailNotValid: "Please enter a valid email",
  portNotValid: "Please enter a valid port number",
};

export const userString = {
  users: "Users",
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email",
  active: "Active",
  admin: "Is Admin",
  addUser: "ADD USER",
  emailAddressRequired: "Email is required",
  userRoleRequired: "User role is required",
  userPermissionsRequired: "User permissions are required",
  lastLogin: "Last Login",
  activeUser: "Active User",
  role: "Role",
  permissions: "Permissions",
  customer: "Customer",
  orderEntryCustomer: "Customer",
  invoiceCustomer: "Vendor",
  vendorServiceTypes: "Vendor Service Types",
};

export const referenceNoString = {
  billingCode: "Billing Code",
  billToNumber: "Bill To",
  consignment: "Consignment #",
  customerNo: "Customer #",
  customerPO: "Customer PO #",
  deliveryOrder: "Delivery Order #",
  housebill: "Housebill",
  hpePackId: "HPE Pack Id",
  bolNo: "BOL Number",
  orderNumber: "Order Number",
  po: "PO #",
  proNumber: "Pro Number",
  refNo: "Ref Number",
  salesOrder: "Sales Order #",
  transferNo: "Transfer #",
  shipperReference: "Shipper Ref",
  consigneeReference: "Consignee Ref",
  trailerNo: "Trailer #",
  safeNo: "Safe #",
  shipment: "Shipment #",
  serialNumber: "Serial Number",
  rmaNumber: "RMA#",
};

export const mlResponseString = {
  shipment: "Shipment #",
  customerPO: "Customer PO #",
  po: "PO #",
  rma: "RMA #",
  costCenter: "Cost Center",
  consignment: "Consignment #",
  storeNo: "Store #",
  trailerNo: "Trailer #",
  billingCode: "Billing Code",
  formatDescription: "Format Description",
  hpePackId: "HPE Pack Id",
  bolNo: "BOL Number",
  customerNo: "Customer #",
  salesOrder: "Sales Order #",
  transferNo: "Transfer #",
  deliveryOrder: "Delivery Order #",
  shipperRef: "Shipper Ref",
  orderNumber: "Order Number",
  safeNumber: "Safe #",
  housebill: "Housebill",
  proNumber: "Pro Number",
  refNo: "Ref Number",
  consigneeRef: "Consignee Ref",
  serialNumber: "Serial Number",
  carrier: "Carrier",
  shipDate: "Ship Date",
  declaredValue: "Declared Value",
  shipperCode: "ID Code",
  shipCustomerZip: "Zip",
  shipCustomerPhone: "Phone",
  shipCompanyName: "Company Name",
  shipContactName: "Contact Name",
  shipperNo: "Shipper #",
  consigneeNo: "Consignee #",
  shipCustomerAddress: "Address1",
  shipCustomerAddress2: "Address2",
  shipCustomerCity: "City",
  shipCustomerState: "State",
  shipCustomerCountry: "Country",
  shipCustomerEmail: "Email",
  selectDate: "Select Date",
  hazmat: "Hazmat",
  scrap: "Is Scrap",
  thisShipmentContainHazardousMaterial:
    "This shipment contains hazardous materials",
  isPiaggioInterGlobe: "Is InterGlobo",
  specialInstructions: "Special Instructions",
  pickupInstructions: "Pickup Instructions",
  isReturnTo: "Return To",
  isVessel: "Is Vessel",
  isPickupFrom: "Pickup From",
  de: "DE",
  nj: "NJ",
  isSpecialEquipment: "Special Equipment",
  goodsName: "Name",
  goodsClass: "Class",
  emergencyContact: "Emergency Contact",
  shipmentType: "Shipment Type",
  isRMA: "RMA",
  dropOff: "Drop Off",
  pickup: "Pickup",
  truckLoad: "Truckload",
  atmId: "ATM ID",
};

export const mlItemsString = {
  name: "Name",
  description: "Description",
  quantity: "Quantity",
  weight: "Weight",
  weightUnit: "Weight Unit",
  containerType: "Container",
  height: "Height",
  length: "Length",
  width: "Width",
  totalWeight: "Total Weight",
  dimensionUnit: "Dimension Unit",
  dimensions: "(L x W x H)",
  shippingMode: "Shipping Mode",
  partNo: "Part Number",
};
export const activityString = {
  fileName: "File Name",
  orderNumber: "Order Number",
  receivedFrom: "Received from",
  receivedOn: "Received on",
  mlStatus: "ML Status",
  isInvoiceFinalized: "Finalized",
  tmsStatus: "TMS Status",
  activityLog: "Activity Log",
  lineItem: "LINE ITEM",
  status: "Status",
  housebillNo: "Housebill #",
  invoiceId: "Invoice #",
  consolNo: "Consol #",
  invoiceDate: "Invoice Date",
  serviceType: "Service Type",
  invoiceAmount: "Invoice Amount",
  vendorId: "Vendor ID",
  vendorNo: "Remit Vendor No",
  vendorName: "Vendor Name",
};

export const podDocumentString = {
  billTo: "Bill To",
  companyName: "Company Name",
  housebill: "Housebill",
  processedStatus: "Processed Status",
  isProcessed: "Processed",
  processedDate: "Processed Date",
  createdDate: "Created Date",
  podName: "POD Name",
  podDateTime: "POD Date Time",
  totalCount: "Total Count",
};

export const dashboardString = {
  customer: "Customer",
  vendor: "Vendor",
  success: "Success",
  failed: "Failed",
  resolved: "Resolved",
  processing: "In Queue",
  total: "Total",
  date: "Date",
  dateRange: "Date Range",
};

export const configurationString = {
  email: "Email",
  notification: "Notification",
  orderNotification: "Order Notification",
  invoiceNotification: "Invoice Notification",
  portRequired: "Port is required",
  noPermission:
    "You don't have permission for settings, please contact IT Team.",
};

export const emailString = {
  popServer: "POP3 Server",
  port: "Port",
  email: "Email",
  password: "Password",
  ssl: "SSL/TSL",
};

export const ltlCustomersString = {
  customerLog: "LTL Customers",
  addCustomer: "ADD CUSTOMER",
  addAddress: "ADD ADDRESS",
  companyName: "Customer Name",
  contactName: "Contact Name",
  wtCode: "WT Code",
  email: "Email",
  phone: "Phone",
  address1: "Address1",
  address2: "Address2",
  city: "City",
  state: "State",
  zip: "Zip",
  hours: "Hours",
  isDelayedDeparture: "Delivery Appt. Required",
  specialInstructions: "Special Instructions",
};

export const lozierStoreString = {
  customerLog: "Lozier Store",
  addCustomer: "Add Store",
  storeNo: "Store No",
  scheduledStartDate: "Scheduled Start Date",
  address: "Address",
  city: "City",
  state: "State",
  zip: "Zip",
  phone: "Phone",
  createdBy: "Created By",
  updatedBy: "Updated By",
};
export const ecolabItemsString = {
  customerLog: "Ecolab Item Details",
  itemDetailsAddLog: "Add Item Details",
  itemDetailsEditLog: "Edit Item Details",
  addItem: "ADD ITEM",
  description: "Description",
  shortDescription: "Short Description",
  length: "Length",
  width: "Width",
  height: "Height",
  createdBy: "Created By",
  updatedBy: "Updated By",
};

export const piaggioCustomersString = {
  customerLog: "Piaggio Addresses",
  itemDetailsLog: "Piaggio Item Details",
  itemDetailsEditLog: "Edit Item Details",
  addItem: "ADD ITEM",
  itemDetailsAddLog: "Add Item Details",
  customerDetailsLog: "Piaggio Address Details",
  customerDetailsEditLog: "Edit Address Details",
  pickupDateTime: "Pickup Date Time",
  pickupCloseDateTime: "Pickup Close Date Time",
  scheduledDeliveryDateTime: "Scheduled Delivery Date Time",
};
export const cardtronicsCustomersString = {
  customerLog: "Cardtronics Addresses",
  customerDetailsLog: "Cardtronics Address Details",
};
export const HPECustomersString = {
  customerLog: "HPE Addresses",
  customerDetailsLog: "HPE Address Details",
};
export const CalixNetworksCustomersString = {
  customerLog: "Calix Networks Addresses",
  customerDetailsLog: "Calix Networks Address Details",
};

export const nautilusCustomerString = {
  customerLog: "Nautilus Item Details",
};

export const notificationsString = {
  recipients: "Recipients",
  success: "Send success notifications",
  failure: "Send failure notifications",
  invalid: "Send Invalid notifications",
};

export const carrierTrackingActivityString = {
  activityTab: "Carrier Activity",
  configurationTab: "Carrier Configuration",
  milestonesTab: "Carrier Milestones",
  trackingActivity: "Carrier Tracking Activity",
  activityInfo:
    "View and monitor carrier activity and manage carrier configurations and milestones.",
  addCarrierConfiguration: "Add Carrier Configuration",
  editCarrierConfiguration: "Edit Carrier Configuration",
  addMilestone: "Add Milestone",
  editMilestone: "Edit Milestone",
  addCarrierConfigurationButton: "ADD CARRIER CONFIGURATION",
  addMilestoneButton: "ADD MILESTONE",
  milestones: "Milestones",
  all: "ALL",
  customerName: "Customer Name",
  carrierName: "Carrier Name",
  carrierCode: "Carrier Code",
  trackingUrl: "Tracking URL",
  userName: "User Name",
  password: "Password",
  processingFrequency: "Processing Frequency",
  processingDelay: "Processing Delay",
  yes: "Yes",
  no: "No",
  milestoneCode: "Milestone Code",
  eventCode: "Event Code",
  reference: "Reference",
  podDateTime: "POD Date Time",
  updatedOn: "Updated On",
  serviceLevel: "Service Level",
  eventDateTime: "Event Date & Time",
  timezone: "Timezone",
  latitude: "Latitude",
  longitude: "Longitude",
  enterBillTo: "Enter Bill To",
  enterCustomerName: "Enter Customer Name",
  enterCarrierName: "Enter Carrier Name",
  enterCarrierCode: "Enter Carrier Code",
  enterTrackingUrl: "Enter Tracking URL",
  selectMilestoneCode: "Select Milestone Code",
  billToRequired: "Bill To is required",
  customerNameRequired: "Customer Name is required",
  carrierNameRequired: "Carrier Name is required",
  carrierCodeRequired: "Carrier Code is required",
  trackingUrlRequired: "Tracking URL is required",
  milestoneCodeRequired: "Milestone code is required",
  eventCodeRequired: "Event code is required",
  descriptionRequired: "Description is required",
  pieces: "Pieces",
  address: "Address",
  airportCode: "Airport Code",
};
